<div class="editor">

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center"
      (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>

    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'"
      class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>


  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
  </div>


  <!-- --------------------------------------------------------- CẤU HÌNH CƠ BẢN --------------------------------------------------------- -->
  <ng-container *ngIf="configMode == 'basic'">
    <div>
      <app-borders-config [device]="device" [elementChoosing]="objectChoosing" [class]="class"
        [borderClass]="class['video__iframe']" [id_object]="objectChoosing._id">
      </app-borders-config>
    </div>
  </ng-container>


  <!-- -------------------------------------------------------- CẤU HÌNH NÂNG CAO -------------------------------------------------------- -->
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline">
      <!-- ẨN HIỆN -->
      <li class="p-0" nz-submenu [nzTitle]="'an_hien' | translate" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
        </app-hide-show-config>
      </li>

      <!-- KIỂU VIỀN -->
      <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <app-borders-config [device]="device" [elementChoosing]="objectChoosing" [class]="class"
          [borderClass]="class['video__iframe']" [id_object]="objectChoosing._id">
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="item-border my-3" style="float: right; cursor: pointer;">
          <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- -------------------------------------------------------- CẤU HÌNH CHI TIẾT -------------------------------------------------------- -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết đường viền -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class"
        [borderRadiusClass]="class['video__iframe']" [id_object]="objectChoosing._id">
      </app-borders-radius-config>
    </div>
  </div>
</div>